module.exports = __webpack_public_path__ + "media/images/items/big-2-d2dc00a617c3f9d5c65890f8987131c9.jpg";